import React from 'react';
import Bio from './Bio';
import Navigation from "./Navigation";
import {Route, BrowserRouter as Router, Routes} from "react-router-dom";
import Translation from "./translations/Translation";
import Home from "./Home";
import HorsesHooves from "./translations/zhuangzi/HorsesHooves";
import LordOfTheCenter from "./translations/zhuangzi/LordOfTheCenter";
import Zhuangzi from "./translations/zhuangzi/Zhuangzi";
import QinGuan from "./translations/qinguan/QinGuan";
import ChillFogLights from "./translations/qinguan/ChillFogLights";
import Lucan from "./translations/lucan/Lucan";
import TheLybianSerpents from "./translations/lucan/TheLybianSerpents";
import Borges from "./translations/borges/Borges";
import TheAmphisbaena from "./translations/borges/TheAmphisbaena";
import Jan152023MlkDayAmphisbaenae from "./blog/Jan152023MlkDayAmphisbaenae";
import Reading from "./reading/Reading";
import Metazoa from "./reading/godfreysmith/Metazoa";
import TheLifecycleOfSoftwareObjects from "./reading/chiang/TheLifecycleOfSoftwareObjects";
import SeaGrapes from "./reading/walcott/SeaGrapes";

function App() {
    return (
        <Router>
            <Navigation />
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/blog/mlk-day-amphisbaenae" element={<Jan152023MlkDayAmphisbaenae />} />
                <Route path="/bio" element={<Bio />} />
                <Route path="/translation" element={<Translation />} />
                <Route path="/translation/borges" element={<Borges />} />
                <Route path="/translation/borges/the-amphisbaena" element={<TheAmphisbaena />} />
                <Route path="/translation/lucan" element={<Lucan />} />
                <Route path="/translation/lucan/the-lybian-serpents" element={<TheLybianSerpents />} />
                <Route path="/translation/qinguan" element={<QinGuan />} />
                <Route path="/translation/qinguan/chill-fog-lights" element={<ChillFogLights />} />
                <Route path="/translation/zhuangzi" element={<Zhuangzi />} />
                <Route path="/translation/zhuangzi/horses-hooves" element={<HorsesHooves />} />
                <Route path="/translation/zhuangzi/lord-of-the-center" element={<LordOfTheCenter />} />
                <Route path="/reading" element={<Reading />} />
                <Route path="/reading/the-lifecycle-of-software-objects" element={<TheLifecycleOfSoftwareObjects />} />
                <Route path="/reading/metazoa" element={<Metazoa />} />
                <Route path="/reading/sea-grapes" element={<SeaGrapes />} />
            </Routes>
        </Router>
    );
}

export default App;
